export const IFRAME_SCOPES = "microphone;camera;clipboard-write;display-capture;";
